import equal from 'fast-deep-equal/es6';
import {
  IDynamicRuleSetOptions,
  IGameRules,
  SpecialCardPlayMode,
} from '../../../Models/GameSetupModels';
import { describeRanks, joinSummary } from '../FeltMat/feltRules';

export const SEBS_RULES: IGameRules = {
  dynamicRuleSetOptions: {
    canPickupVisibleCardsAsPartOfPlay: true,
    mustPlayIfCanPlay: true,
    mustShowHiddenFlip: true,
    numberInARowToBurn: 4,
    playAfterWinner: true,
    playAgainAfterForcingAPickup: false,
    specialCards: {
      TEN: {
        burns: true,
        playMode: SpecialCardPlayMode.CanAlwaysPlay,
        resetsThePile: false,
        switchesNextPlayToDescending: false,
        glass: false,
      },
      TWO: {
        burns: false,
        playMode: SpecialCardPlayMode.CanAlwaysPlay,
        resetsThePile: true,
        switchesNextPlayToDescending: false,
        glass: false,
      },
      EIGHT: {
        burns: false,
        playMode: SpecialCardPlayMode.Unmodified,
        resetsThePile: false,
        switchesNextPlayToDescending: true,
        glass: false,
      },
    },
  },
  numberOfHandCards: 3,
  numberOfHiddenCards: 3,
  numberOfVisibleCards: 3,
};

const NANS_RULES: IGameRules = {
  dynamicRuleSetOptions: {
    canPickupVisibleCardsAsPartOfPlay: false,
    mustPlayIfCanPlay: true,
    mustShowHiddenFlip: false,
    numberInARowToBurn: 4,
    playAfterWinner: false,
    playAgainAfterForcingAPickup: true,
    specialCards: {
      TEN: {
        burns: true,
        playMode: SpecialCardPlayMode.CanAlwaysPlayExceptOnDescending,
        resetsThePile: false,
        switchesNextPlayToDescending: false,
        glass: false,
      },
      TWO: {
        burns: false,
        playMode: SpecialCardPlayMode.CanAlwaysPlay,
        resetsThePile: true,
        switchesNextPlayToDescending: false,
        glass: false,
      },
      SEVEN: {
        burns: false,
        playMode: SpecialCardPlayMode.Unmodified,
        resetsThePile: false,
        switchesNextPlayToDescending: true,
        glass: false,
      },
      THREE: {
        burns: false,
        playMode: SpecialCardPlayMode.CanAlwaysPlay,
        resetsThePile: false,
        switchesNextPlayToDescending: false,
        glass: true,
      },
    },
  },
  numberOfHandCards: 3,
  numberOfHiddenCards: 3,
  numberOfVisibleCards: 3,
};

export const RULESETS = [
  { name: `Seb's Rules`, rules: SEBS_RULES },
  { name: `Nan's Rules`, rules: NANS_RULES },
];

export const CUSTOM_RULESET = 'Custom';

export function rulesetName(rules: IGameRules) {
  return (
    RULESETS.find((ruleset) => equal(rules, ruleset.rules))?.name ??
    CUSTOM_RULESET
  );
}

export function rulesetNameFromOptions(options: IDynamicRuleSetOptions) {
  return (
    RULESETS.find((ruleset) =>
      equal(options, ruleset.rules.dynamicRuleSetOptions)
    )?.name ?? CUSTOM_RULESET
  );
}

export function rulesSummary(options: IDynamicRuleSetOptions) {
  return joinSummary([
    describeRanks(options, (card) => card.resetsThePile, 'reset'),
    describeRanks(options, (card) => card.burns, 'burn'),
    describeRanks(
      options,
      (card) => card.switchesNextPlayToDescending,
      'switch to lower'
    ),
    describeRanks(options, (card) => card.glass, 'are glass'),
  ]);
}
